module.exports = __webpack_public_path__ + "img/germany-neoplasm-female.15c0aed8.png";